import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchChainSalesRank = (retailerId) => {
  const { url } = DepsService.rest.widgets.chainRanks;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/chain-sales-rank.api.js